import { Link } from 'react-router-dom'
import { BRAND, type BrandLogoProps } from '../constants/brand'
import { APP_ROUTES } from '../constants/routes'
import { cx } from '../helpers/format'
import '../styles/brand-logo.scss'

export function BrandLogo({ to = APP_ROUTES.home }: BrandLogoProps) {
  return (
    <Link to={to} className={cx('brand-logo')} aria-label={BRAND.name}>
      <img
        src={BRAND.logoSrc}
        alt={BRAND.logoAlt}
        className="brand-logo__image"
        width={BRAND.logoWidth}
        height={BRAND.logoHeight}
      />
    </Link>
  )
}
